// 全局变量 存储token和用户信息等
const userInfoObject = {
  user: {},
};
export default userInfoObject;
